'use client';

import { LightBulbIcon } from '@heroicons/react/24/outline';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/solid';
import { useRef, useState } from 'react';
import { Button } from '../../../../../../../actions/Button';
import { LightCard } from '../../../../../../../data-display/Card';
import { H3 } from '../../../../../../../typography/Heading';
import { P2 } from '../../../../../../../typography/Paragraph';
type DeepDiveProps = {
  title: string;
  children: React.ReactNode;
  open?: boolean;
};
export function DeepDiveCard({
  title,
  children,
  open = false
}: DeepDiveProps) {
  const [isOpen, setIsOpen] = useState<boolean>(open);
  const contentRef = useRef<HTMLDivElement>(null);
  return <LightCard className='w-full space-y-4 border-borderColor bg-backgroundBlue'>
      <P2 className='flex items-center gap-2 font-semibold text-contentColorPrimary'>
        <LightBulbIcon className='h-6 w-6' />
        Dowiedz się więcej
      </P2>

      <H3>{title}</H3>

      <div ref={contentRef} style={{
      maxHeight: isOpen ? contentRef.current?.scrollHeight : 0
    }} className='overflow-hidden duration-300 ease-in-out'>
        <div className='space-y-2 font-normal text-base text-contentColorPrimary leading-6'>
          {children}
        </div>
      </div>

      <Button onClick={() => setIsOpen(!isOpen)} className='flex items-center gap-2'>
        {isOpen ? 'Ukryj szczegóły' : 'Pokaż szczegóły'}
        {isOpen ? <ChevronUpIcon className='h-5 w-5' /> : <ChevronDownIcon className='h-5 w-5' />}
      </Button>
    </LightCard>;
}